import { render, staticRenderFns } from "./Wmts.vue?vue&type=template&id=89b01134"
import script from "./Wmts.vue?vue&type=script&lang=js"
export * from "./Wmts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports